import { AlertsManagement } from "~/components/admin/dashboard/components/AlertsManagement";

export const ScreenAlerts = () => {
  return <AlertsManagement />;
};